import { render, staticRenderFns } from "./RoomTemplates.vue?vue&type=template&id=28ece232"
import script from "./RoomTemplates.vue?vue&type=script&lang=js"
export * from "./RoomTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports